import { io, type Socket } from 'socket.io-client'
import { getToken } from '../utils'

export const socket: Socket = io(import.meta.env.VITE_SOCKET_URL || 'http://localhost:3000', {
  autoConnect: false,
  transports: ['polling', 'websocket'], // Allow both polling and websocket
  // Keep trying while the chat API is down (a deploy can take longer than 5
  // attempts); giving up would freeze chat until the page is reloaded.
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 30000,
  forceNew: false,
  upgrade: true,
  rememberUpgrade: true,
  auth: (cb) => {
    const token = getToken()
    cb({ token })
  },
})